export default __webpack_public_path__ + "static/media/fasad10.9f2fe95c.jpeg";